import { render } from "./LightGallery.vue?vue&type=template&id=47173610"
import script from "./LightGallery.vue?vue&type=script&lang=ts"
export * from "./LightGallery.vue?vue&type=script&lang=ts"
script.render = render

export default script